import { MatchResults } from '../types/match'

export const getRequiredResult = (
  matchResult: string | null,
  topResult: string,
  okResult: string,
  badResult: string,
  noResult = ''
): string => {
  switch (matchResult) {
    case MatchResults.great:
    case MatchResults.good:
      return topResult

    case MatchResults.ok:
      return okResult

    case MatchResults.bad:
      return badResult

    default:
      return noResult
  }
}
